import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { List, Paper, Stack, Typography } from '@mui/material';

import { TooltipIconButton } from '@paragon/client-tools';
import { Station } from '@paragon/contract-library';
import { sortBy } from '@paragon/utilities';

import { showStationInsertionDialog } from '../../../actions/dialogActions';
import { StationViewModel } from '../../../selectors/holisticViewModelSelector';
import { useAppDispatch } from '../../hooks';
import { LineListItem } from './LineListItem';

interface LinesListProps {
  station: Station;
  stationViewModel: StationViewModel;
  isSupervisor: boolean;
}

export function LinesList({ station, stationViewModel, isSupervisor }: LinesListProps) {
  const dispatch = useAppDispatch();

  return (
    <Paper sx={{ padding: 2 }}>
      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Typography variant="h5" sx={{ marginRight: 'auto' }}>
          Lines with this station
        </Typography>

        {isSupervisor && (
          <TooltipIconButton
            title="Add to line"
            onClick={() => void dispatch(showStationInsertionDialog(station.guid))}
          >
            <AddIcon />
          </TooltipIconButton>
        )}
      </Stack>

      {stationViewModel.parents.length > 0 && (
        <List>
          {sortBy(stationViewModel.parents, (line) => line.source.name).map((line) => (
            <LineListItem
              key={line.source.guid}
              line={line.source}
              stationGuid={station.guid}
              isSupervisor={isSupervisor}
            />
          ))}
        </List>
      )}
    </Paper>
  );
}
